/**
 * App default route — Home (specs/home-page AC-1). Supersedes the competitions-hub landing
 * (specs/competitions-hub-client AC-6.2); the hub is still the Tournaments tab, one tap away.
 */

import { HomeScreen } from '../../components/home/HomeScreen/HomeScreen';

export default function AppIndex() {
  return <HomeScreen />;
}
